<template>
  <div>
    <el-dialog
      title=""
      :visible.sync="visible"
      width="50%"
      append-to-body
      :show-close="true"
      top="10vh"
    >
      <div class="main__container">
        <!-- <img
          class="close"
          src="../datav/img/delete.png"
          alt=""
          @click.stop="handlerClose"
        /> -->
        <div class="wrapper2 ml-6">
          <!-- <img src="../datav/img/dialog-bg.png" class="bg-img" alt="" /> -->
          <div class="content">
            <slot></slot>
          </div>
        </div>
        <!-- <div class="wrapper3 ml-6" v-if="archivesDetail.archive.sn">
          <ArchivesCard :sn="checkUsers.sn" :detail="archivesDetail" />
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      keyUser: "",
      filterUserList: [],
      checkUsers: [],
      archivesDetail: {
        archive: {
          sn: null,
        },
      },
      visibleArchives: false,
    };
  },

  props: {
    show: Boolean,
  },

  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
  watch: {
    show(n) {
      if (n) {
      }
    },
  },
  methods: {
    handlerClose() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>
<style lang="less" scoped>
.main__container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}
.wrapper1,
.wrapper2,
.wrapper3 {
  position: relative;
}

.wrapper2 {
  width: 100%;
  height: 620px;
}
.wrapper3 {
  width: 50%;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 30px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
}
.center-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
  z-index: 11111;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  font-size: 24px;
}
.left-back {
  display: flex;
  align-items: center;
  position: absolute;
  left: 60px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  font-size: 20px;
}
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
}
.content {
  position: relative;
  z-index: 2;
  color: #fff;
  padding-top: 6%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 50px;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
}
.list__container {
  margin-top: 30px;
  height: 370px;
  overflow: scroll;
  .item {
    width: 100%;
    height: 39px;
    background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
    //   opacity: 0.28;

    font-size: 16px;
    color: #01b3e6;
    font-weight: 500;
  }
  .item:hover {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
  .active {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
}
.table-name {
  color: #abd1e7;
}
// ::v-deep {
//   .el-dialog {
//     // 取消阴影和背景色
//     background: rgba(0, 0, 0, 0);

//     -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

//     box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
//   }
//   .el-input__inner {
//     height: 42px;
//     border: 1px solid #077fd4;
//     border-radius: 8px;
//     background: none;
//     color: #01b3e6;
//   }
//   .el-dialog__headerbtn {
//     top: 78px;
//     right: 100px;
//     z-index: 122;
//     font-size: 30px;
//     color: #fff;
//     font-size: bold;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: #fff;
//   }
//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//   }
//   .el-table tbody tr:hover > td {
//     background-color: #17468d !important //修改成自己想要的颜色即可
// ;
//   }
// }
</style>
